<route>
{
  "meta": {
    "permission": [
      "sales.view_suborderdate"
    ]
  }
}
</route>

<template>
  <div>
    <dialdate
      v-model="dialog"
      :to-edit="toEdit"
      ref="dialdate"
      :template="template"
      :order="order"
      @done="reload = true"
    />
    <i-card-list
      class="mt-2 px-2"
      :title="$t('dates')"
      dontHeader
      app="sales.suborderdate"
      api="suborder.date"
      :method="'show'"
      :inactive="'changeDate'"
      :requestOpts="{ pk: order }"
      :opt="{ order: true }"
      :reload.sync="reload"
      @click:create="open()"
      @click:edit="open($event)"
    >
      <template v-slot:[`item`]="{ item }">
        <v-chip
          v-if="item.changeDate"
          class="font-weight-bold mr-2"
          outlined
          color="error"
          small
          pill
        >
          {{ $t('previous_date') }}
        </v-chip>
        <p class="title font-weight-black primary--text mb-2">
          {{ dateFormat(item.date) }}
        </p>
        <p class="grey--text">
          <span class="font-weight-black">
            {{ `${$t('typedate')}: ` }}
          </span>
          {{ item.typeName }}
        </p>
        <v-list v-show="item.observation !== ''" class="py-0 mb-2" dense>
          <v-list-group @click.stop="">
            <v-icon slot="appendIcon" size="12">fas fa-arrow-down</v-icon>
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>
                  <span class="primary--text subtitle-2 font-weight-black">
                    {{ $tc('observation', 2) }}
                  </span>
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <p class="px-2">{{ item.observation }}</p>
          </v-list-group>
        </v-list>
      </template>
    </i-card-list>
  </div>
</template>
<script>
import dialdate from './dialDate.vue'
export default {
  components: {
    dialdate
  },
  props: {
    order: {
      required: true,
      type: Number
    },
    template: {
      type: Number
    }
  },
  data: () => ({
    dates: [],
    loading: false,
    reload: false,
    dialog: false,
    toEdit: null
  }),
  methods: {
    open(item) {
      this.toEdit = item === undefined ? null : item
      this.dialog = true
    }
  }
}
</script>
